import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticlePreview() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-widest text-foreground-400 font-medium mb-3">
            KakobuyFinds Blog
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            {t("articles.section_title")}
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            {t("articles.section_subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/artykul/${article.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 flex flex-col"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-900">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                    {article.readTime} {t("articles.min_read")}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <p className="text-xs text-foreground-400 mb-2">{article.date}</p>
                <h3 className="text-sm font-bold text-foreground-900 leading-snug line-clamp-2 group-hover:text-foreground-700 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-foreground-900 group-hover:gap-2 transition-all duration-200">
                  {t("articles.read_more")}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}